module.exports = {
  NO: 'no',
  BLOCK: 'block',
  PROCESSING: 'processing'
}
